import DisposableClass, * as DisposableModule from './../node_modules/ol/Disposable.js';

// Create a wrapper class
class Disposable extends DisposableClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in DisposableModule) {
    if (key !== "default") {
        Disposable[key] = DisposableModule[key];
    }
}

export default Disposable;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/Disposable.js';